var _title, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWpLogoCancelled = function SvgWpLogoCancelled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "250px",
    height: "260px",
    viewBox: "0 0 250 260",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Branding/Wonderpass/WP-Logo-Icon BW@1x")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.0625,258.52 L2.0625,124.418 C2.0625,56.523 57.1055,1.48 125.0005,1.48 C186.7265,1.48 237.8285,46.971 246.6065,106.254 C247.4845,112.186 247.9375,118.25 247.9375,124.418 L247.9375,258.52 L2.0625,258.52 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Branding/Wonderpass/WP-Logo-Icon-BW",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Archi",
    fill: "#CAD1E2",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "w",
    mask: "url(#mask-2)",
    fill: "#434F69"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36.034100, 105.500000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "150 0 190 0 150 125 115 125 95 58.25 75 125 40 125 0 0 40 0 58 67 77.5 0 112.5 0 132 67"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWpLogoCancelled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wp_logo_cancelled.03373f18.svg";
export { ForwardRef as ReactComponent };